// extracted by mini-css-extract-plugin
module.exports = {"edit_caution_list":"User_edit_caution_list__BKOY8","edit_btn":"User_edit_btn__1v5tF","edit_input_area":"User_edit_input_area__11CwE"};